import Vue from 'vue'
import CharactersAvailable from  '@/components/simulator/CharactersAvailable.vue'

Vue.component('characters-available', CharactersAvailable)